import { render, staticRenderFns } from "./OrdersFeatureCard.vue?vue&type=template&id=046e7e70"
import script from "./OrdersFeatureCard.vue?vue&type=script&lang=js"
export * from "./OrdersFeatureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports